import { defineStore } from 'pinia';

const useLearnSkillsStore = defineStore('learnSkill', {
  state: () => {
    return {
      lessons: [],
    };
  },
  getters: {
    getLessonById: (state) => {
      return (lessonId) => state.lessons.find((lesson) => Number(lesson.id) === Number(lessonId));
    },
    getLessons: (state) => {
      return () => state.lessons;
    },
  },
  actions: {
    setLessons(lessons) {
      this.lessons = lessons;
    },
    resetLessons() {
      this.lessons = [];
    },
  },
});

export { useLearnSkillsStore };
